module.exports = __webpack_public_path__ + "static/media/growth.bfb4a78e.png";